module.exports = __webpack_public_path__ + "static/android-4eef6bd3e4d72e2743caa265cbbe1356.svg";